<template>
  <div id="balance">
    <div class="balance-header">
      <div class="filter-date">
        <el-date-picker
          class="date-picaker"
          v-model="exportPublicAuditTime"
          type="daterange"
          range-separator=" ~ "
          align="left"
          placeholder="选择日期范围"
          unlink-panels
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
      <div class="export-balance-detail">
        <json-excel
          :fields="json_fields"
          class="demonstration"
          :fetch="exportBalance"
          :name="filename"
        >
          <button class="s-btn btn-blue is-plain" :disabled="loading">
            <i v-show="loading" class="el-icon-loading"></i>下载Excel
          </button>
        </json-excel>
      </div>
    </div>

    <table class="list-header" rules="groups" frame="box">
      <thead>
        <tr>
          <th width="180px">时间</th>
          <th class="text-center">汇款金额(元)</th>
          <th class="text-center">汇款凭证</th>
          <th class="text-center">操作人</th>
          <th class="text-center">状态</th>
          <th width="200px">备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(v, k) in publicAuditList" :key="k">
          <td>{{ v.submit_time }}</td>
          <td class="text-center">{{ v.amount / 100 }}</td>
          <td class="text-center">
            <span
              class="view-text"
              @click="previewImage(v.voucher_document_key)"
              >查看</span
            >
          </td>
          <td class="text-center">{{ v.peer_account_name }}</td>
          <td class="text-center">{{ auditStatusMap[v.status] }}</td>
          <td>{{ v.memo }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="!publicAuditList.length" class="no-data">
      <img
        class="nodata-img"
        src="../../../assets/imgs/new-user/balance-nodata.png"
        alt=""
      />
      <div class="nodata-text">未查询到对公汇款记录</div>
    </div>

    <div class="page" v-if="totalCount">
      <el-pagination
        class="text-center"
        @current-change="getData"
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="汇款回执预览"
      :show-close="true"
      v-model="showPreviewImage"
      id="cover-box"
    >
      <div class="preview-container">
        <img :src="currentImageSrc" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import JsonExcel from 'vue-json-excel';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';
import User from '../../../libs/user';

const auditStatusMap = {
  0: '处理中',
  1: '充值成功',
  2: '充值失败',
};

export default {
  components: {
    JsonExcel,
  },
  data() {
    return {
      queryParams: { currentPage: 1 },
      popBox: false,
      publicAuditList: [],
      page: 1,
      totalCount: 0,
      peer: User.peer || {},
      exportPublicAuditTime: [null, null],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '全部',
            onClick(picker) {
              picker.$emit('pick', []);
            },
          },
        ],
      },
      loading: false,
      json_data: [],
      filename: '',
      json_fields: {
        时间: 'submit_time',
        '汇款金额（元）': 'amount',
        汇款凭证: 'voucher_document_key',
        操作人: 'peer_account_name',
        状态: 'status',
        备注: 'memo',
      },
      auditStatusMap,
      currentImageSrc: '',
      showPreviewImage: false,
    };
  },
  watch: {
    exportPublicAuditTime() {
      this.page = 1;
      this.getData(1);
    },
  },
  methods: {
    previewImage(url) {
      this.currentImageSrc = [url];
      this.showPreviewImage = true;
    },
    getAuditData(obj) {
      Http.post('/visa_peer_corporate_remittance_brief_query', obj)
        .then((data) => {
          this.publicAuditList = data.page_data || data;
          this.totalCount = data.total_count || 0;
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    getData(page) {
      const obj = {
        page,
      };

      if (
        this.exportPublicAuditTime.length > 0 &&
        this.exportPublicAuditTime[0]
      ) {
        obj.start_submit_date = utils.formatDate(
          this.exportPublicAuditTime[0],
          'yyyy-MM-dd',
        );
        obj.end_submit_date = utils.formatDate(
          this.exportPublicAuditTime[1],
          'yyyy-MM-dd',
        );
      }

      this.getAuditData(obj);
    },
    getExportData() {
      const obj = {
        is_export: 1,
        page: 1,
      };

      if (
        this.exportPublicAuditTime.length > 0 &&
        this.exportPublicAuditTime[0]
      ) {
        obj.start_submit_date = utils.formatDate(
          this.exportPublicAuditTime[0],
          'yyyy-MM-dd',
        );
        obj.end_submit_date = utils.formatDate(
          this.exportPublicAuditTime[1],
          'yyyy-MM-dd',
        );
      }

      const reg = new RegExp('-', 'g');
      if (
        this.exportPublicAuditTime.length > 0 &&
        this.exportPublicAuditTime[0]
      ) {
        this.filename = `${obj.start_submit_date.replace(
          reg,
          '',
        )}-${obj.end_submit_date.replace(reg, '')} 对公汇款明细`;
      } else {
        this.filename = '对公汇款明细';
      }

      const dataMatch = {
        submit_time: '时间',
        amount: '汇款金额（元）',
        voucher_document_key: '汇款凭证',
        peer_account_name: '操作人',
        status: '状态',
        memo: '备注',
      };

      return new Promise((resolve) => {
        const exportData = [];
        Http.post('/visa_peer_corporate_remittance_export', obj)
          .then((data) => {
            if (!data.page_data.length) {
              Message.warning({
                message: '无对公汇款明细可导出',
              });
            }

            data.page_data.forEach((item) => {
              const obj = {};
              Object.keys(item).forEach((key) => {
                if (dataMatch[key] !== undefined) {
                  const single = item[key];
                  obj[key] = single;
                }
              });
              obj.amount = item.amount / 100;
              obj.status = auditStatusMap[item.status];

              exportData.push(obj);
            });

            resolve(exportData);
          })
          .catch((e) => {
            if (e) console.log(e);
          });
      });
    },
    async exportBalance() {
      this.loading = true;

      const exportData = await this.getExportData();
      this.loading = false;
      return exportData;
    },
  },
  created() {
    const _this = this;

    Http.post('/peer_account_query', {})
      .then((data) => {
        if (!data.wxinfo && !User.is_palmyou) {
          this.$router.replace({
            name: 'bind',
            query: { redirectUrl: encodeURIComponent(this.$route.fullPath) },
          });
        }
      })
      .catch((e) => {
        if (e) console.log(e);
      });

    Http.post('/visa_peer_query')
      .then((data) => {
        _this.peer = data;
        utils.extend(User.peer, data);
      })
      .catch((e) => {
        if (e) console.log(e);
      });

    this.getAuditData({ page: 1 });
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
#balance {
  padding: 24px;

  .balance-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .filter-date {
      .date-picaker {
        width: 340px;
        /deep/ .el-input__inner {
          height: 40px;
        }
      }
    }
    .export-balance-detail {
      display: flex;
      align-items: center;
      .demonstration {
        font-size: 14px;
        color: #5e9be1;
        font-weight: normal;
        cursor: pointer;
        margin-left: 10px;
        .el-icon-loading {
          margin-right: 3px;
        }
      }
    }
  }
  .list-header {
    width: 100%;
    font-size: 14px;
    margin: 24px 0 0 0;
    border: none;
    color: #2f333d;
    thead {
      border: 1px solid #e9eef2;
      th {
        background-color: #fafbfc;
        padding: 0 16px;
        text-align: left;
        font-weight: 600;
        height: 60px;
      }
    }
    tbody {
      tr {
        border-bottom: 1px solid #e9eef2;
        td {
          padding: 16px;
          height: 68px;
          background-color: #fff;
          word-break: break-all;
          &.list-td-memo {
            line-height: 20px;
            padding: 16px 5px;
            display: flex;
            align-items: center;
            .api-tag {
              display: inline-block;
              flex-shrink: 0;
              height: 20px;
              width: 40px;
              background: url(../../../assets/imgs/new-user/icon-api.png)
                no-repeat center / 100% 100%;
              margin-left: 4px;
            }
          }
        }
      }
    }

    .items-sbtn {
      width: 76px;
      height: 26px;
      font-size: 13px;
    }
    .text-center {
      text-align: center;
    }
  }

  .no-data {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    .nodata-img {
      width: 200px;
      height: 120px;
    }
    .nodata-text {
      color: #91999f;
      font-size: 16px;
      margin-top: 11px;
    }
  }

  .el-button {
    width: 78px;
    height: 28px;
    padding: 0;
  }
  .page {
    height: 140px;
    position: relative;
    .text-center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
    }
  }
  .view-text {
    color: #599fff;
    cursor: pointer;
  }
  #cover-box {
     /deep/.el-dialog__header {
      display: block;
      padding: 20px;
      border-bottom: 1px solid #e9eef2;
    }

    /deep/.el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px 20px;
      max-height: 500px;
      overflow: hidden;
      .preview-container {
        width: 100%;
        height: 440px;
        margin: 0 auto;
        border: 1px solid #e9eef2;
        border-radius: 8px;
        overflow: scroll;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/PublicAudit.vue